import { createAction } from 'redux-actions';

export const setIsLoading = createAction('PAGE/SET_IS_LOADING');
export const unsetIsLoading = createAction('PAGE/UNSET_IS_LOADING');
export const userFailLoadData = createAction('PAGE/USER_FAIL_LOAD_DATA', error => error);
export const clearCountError = createAction('PAGE/CLEAR_COUNT_ERROR_LOAD_USER');
export const setCountLoadUser = createAction('PAGE/COUNT_ERROR_LOAD_USER', count => count);
export const setAuthenticated = createAction('PAGE/SET_IS_AUTHENTICATED');
export const setCount = createAction('PAGE/PLUS_ONE');
